let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7HCHi")).then(() => parcelRequire('fB2L1'));